var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStressHigh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4514_2543)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 0C62.0906 0 80 17.9094 80 40C80 62.0906 62.0906 80 40 80C17.9094 80 0 62.0906 0 40C0 17.9094 17.9094 0 40 0ZM60.8844 26.5859C60.6047 25.7422 59.6969 25.2844 58.8453 25.5672L47.2313 29.4375C46.3875 29.7187 45.9297 30.6328 46.2125 31.4781C46.4359 32.1531 47.0672 32.5812 47.7422 32.5812C47.9109 32.5812 48.0828 32.5547 48.2516 32.4984L59.8656 28.6266C60.7094 28.3453 61.1672 27.4328 60.8844 26.5859ZM53.5484 43.8703C55.3297 43.8703 56.775 42.4266 56.775 40.6453V38.0641C56.775 36.2828 55.3297 34.8391 53.5484 34.8391C52.6578 34.8391 51.8516 35.2 51.2687 35.7844C50.6844 36.3672 50.3234 37.1734 50.3234 38.0641V40.6453C50.3234 42.4266 51.7672 43.8703 53.5484 43.8703ZM30.7312 59.1266C33.6344 58.5547 36.7562 58.2422 40.0094 58.2422C43.2625 58.2422 46.3844 58.5547 49.2859 59.1266C50.2031 59.3078 50.9125 58.3703 50.5531 57.5063C48.7937 53.2828 44.7391 50.3219 40.0094 50.3219C35.2797 50.3219 31.225 53.2828 29.4656 57.5063C29.1062 58.3703 29.8141 59.3078 30.7312 59.1266ZM23.2266 40.6453C23.225 42.4266 24.6703 43.8703 26.4516 43.8703C28.2328 43.8703 29.6766 42.4266 29.6766 40.6453V38.0641C29.6766 36.2828 28.2328 34.8391 26.4516 34.8391C25.5609 34.8391 24.7547 35.2 24.1719 35.7844C23.5875 36.3672 23.2266 37.1734 23.2266 38.0641V40.6453ZM20.1344 28.6266L31.7484 32.4984C31.9172 32.5547 32.0891 32.5812 32.2578 32.5812C32.9328 32.5812 33.5641 32.1531 33.7875 31.4781C34.0703 30.6328 33.6125 29.7187 32.7687 29.4375L21.1562 25.5672C20.3141 25.2844 19.3969 25.7422 19.1156 26.5859C18.8328 27.4328 19.2906 28.3453 20.1344 28.6266Z",
    fill: "#DD3923"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4514_2543"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white",
    transform: "matrix(-1 0 0 1 80 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStressHigh);
export default __webpack_public_path__ + "static/media/StressHigh.1a15c57dc1eefc596a9be924d1ae70cb.svg";
export { ForwardRef as ReactComponent };